var GROUP_TYPES = {
    1: '1',
    '2v': '2v',
    '2h': '2h',
    '3r': '3r',
    '3b': '3b',
    '3t': '3t',
    '3l': '3l',
    '3v': '3v',
    '3h': '3h',
};
export default GROUP_TYPES;
//# sourceMappingURL=groupTypes.js.map